import moment from "moment";
export const CommonCsvFunctions = {
	methods: {
		checkIfDecimalNumber(n) {
			// returns true if a number a decimal
			return !(n % 1 === 0) ? true : false;
		},
		addError(error) {
			this.errorsInCsv.push(error);
		},
		pushError(object, detail) {
			object.isError = true;
			object.details.push(detail);
		},
		getParticularObject(modifiedRow, rowValue, columnName) {
			modifiedRow[columnName] = {
				value: rowValue,
				isError: false,
				details: [],
				columnName: columnName
			};
			// modifiedRow.push({
			// 	value: rowValue,
			// 	isError: false,
			// 	details: [],
			// 	columnName: columnName
			// });
			return modifiedRow[columnName];
			// return this.findElement(modifiedRow, "value", rowValue);
		},
		findElement(arr, property, propertyValue) {
			// finds element in the array of objects and returns it
			console.log("inside findElement");
			console.log(
				"null",
				arr.find(object => object[property] === propertyValue)
			);
			return arr.find(object => {
				if (object[property] === propertyValue) {
					return object;
				}
			});
		},
		checkDate(value) {
			// const date = moment(value, ["DD-MM-YYYY", "YYYY-MM-DD"]);
			var date = moment(value, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
			// const date1 = moment(value, "YYYY-MM-DD");
			return date;
		},
		checkForUniqueInt(val) {
			var re = new RegExp(/\b((?!CR|cr)[A-Za-z]{2}\d{5,6})\b(?![\s\S]*\b\1\b)/);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForYYYYMMDDDate(val) {
			var re = new RegExp(
				/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForBothDashDate(val) {
			var re = new RegExp(
				/^([0-9]{4}[-](0[1-9]|1[0-2])[-]([0-2]{1}[0-9]{1}|3[0-1]{1})|([0-2]{1}[0-9]{1}|3[0-1]{1})[-](0[1-9]|1[0-2])[-][0-9]{4})$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForDDMMYYYYDate(val) {
			var re = new RegExp(
				/^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-]\d{4}$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},

		checkForTime(val) {
			var re = new RegExp(
				/^(((([0-1]?[0-9])|(2[0-3])):[0-5][0-9](:[0-5][0-9])?)|(24:00(:00)?))$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForAlphaNumeric(val) {
			// if val is alphaNumeric then function returns true else returns false
			var re = new RegExp(/^[a-zA-Z0-9_ ]+$/);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		checkForNumber(n) {
			return Number(n) === n;
		},
		checkForBaseUnit(val) {
			var re = new RegExp(/^[a-zA-Z]+$/);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
		},
		validateEmail(val) {
			var re = new RegExp(
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
			if (re.test(val)) {
				return true;
			} else {
				return false;
			}
			// return re.test(String(email).toLowerCase());
		},
		checkForActiveInactive(val) {
			if (val === "Active " || val === "Active" || val === "Inactive") {
				console.log("true");
				return true;
			} else {
				console.log("false");
				return false;
			}
		},
		checkForString(str) {
			return typeof str === "string";
		},
		checkHeadingsEquality(actual, checkAgainst) {
			checkAgainst = checkAgainst.map(elem => elem.trim());

			return actual.every(elem => checkAgainst.indexOf(elem) > -1);
		}
		// arraysEqual(a, b) {
		// 	if (a === b) return true;
		// 	if (a == null || b == null) return false;
		// 	if (a.length != b.length) return false;

		// 	// If you don't care about the order of the elements inside
		// 	// the array, you should sort both arrays here.
		// 	// Please note that calling sort on an array will modify that array.
		// 	// you might want to clone your array first.

		// 	for (var i = 0; i < a.length; ++i) {
		// 		if (a[i] !== b[i]) return false;
		// 	}
		// 	return true;
		// },
	}
};
